import React from "react";
import {getStaticMediaUrl} from "../../../../utils/Urls";
import zaggleMobileAppWithCard from "../../../../assets/zaggleMobileAppWithCard.svg";

export function BannerImageSection() {
    return <img className="mx-auto" src={getStaticMediaUrl(zaggleMobileAppWithCard)}/>;
}